if (!customElements.get('related-products')) {
    class RelatedProducts extends ProductCardCollection {
        constructor() {
            super();
            this.getrelatedProducts(products => {
                const { showCount } = window.relatedProductsConfiguration;
                this
                    .usingTemplateSelector("template#related-product-card")
                    .displayProducts(products.splice(0, showCount));
            });
        }

        getrelatedProducts(callback) {
            const { productId, intent } = window.relatedProductsConfiguration;

            fetch(`/recommendations/products.json?product_id=${productId}&intent=${intent}`)
                .then(response => response.json())
                .then(({ products }) => callback(products))
                .catch(e => {
                    console.error("Failed to get product recommendations")
                    throw e;
                });
        }
    }

    customElements.define("related-products", RelatedProducts);
}
